import { Toast } from 'vant';
import InsuranceDialog from '@/components/insurance_dialog/insurance_dialog';
import PaymentDialog from '@/components/payment_dialog/payment_dialog';
import csBank from '@/assets/images/provincial/cs_bank.svg';

export default {
	name: 'finance_service',
	data() {
		return {
			isShowPayment: false,
			isShowInsurance: false,
			csBank
		}
	},
	methods: {
		closePayment() {
		    this.isShowPayment = false;
        },
		closeInsurance() {
        	this.isShowInsurance = false;
        },
		wdzf() {
			// window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx87d8c164f712db08&redirect_uri=https%3a%2f%2fm.cs96111.com%2f96111%2fwechat%2foauth%3fscope%3dopenid%26redirect%3dfinance.wdzf%26type%3dnone&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect';
			window.location.href='https://user.cs96111.com/ad/record/url/auth?data=11;39;1';
		},
		wyck() {
			// window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx87d8c164f712db08&redirect_uri=https%3a%2f%2fm.cs96111.com%2f96111%2fwechat%2foauth%3fscope%3dopenid%26redirect%3dfinance.wyck%26type%3dnone&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect';
			window.location.href='https://user.cs96111.com/ad/record/url/auth?data=11;40;1';
		},
		wydk() {
			// window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx87d8c164f712db08&redirect_uri=https%3a%2f%2fm.cs96111.com%2f96111%2fwechat%2foauth%3fscope%3dopenid%26redirect%3dfinance.wydk%26type%3dnone&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect';
			window.location.href='https://user.cs96111.com/ad/record/url/auth?data=11;41;1';
		},
		wxyj() {
        	this.isShowInsurance = true;
        },
        zzjf() {
        	this.isShowPayment = true;
        },
		unable() {
			Toast('功能建设中，敬请期待');
		}
	},
	components: {
		'InsuranceDialog': InsuranceDialog,
		'PaymentDialog': PaymentDialog
	}
}


// WEBPACK FOOTER //
// ./src/components/finance_service/index.js